






import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import ProgressSpinner from "@/components/ui/ProgressSpinner.vue";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Progress container component.
 * It shows progress spinner when data is pending, passed contents otherwise
 */
@Component({
  components: { ProgressSpinner }
})
export default class ProgressContainer extends Vue {
  @Prop() private isPending!: boolean;
}
